import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdvancedAccountSetupDialogComponent } from "../modules/advanced-account-setup-dialog/advanced-account-setup-dialog.component";
import { AdvancedAccountSetupDialogData } from "../types/advanced-account-setup.types";

@Injectable({ providedIn: "root" })
export class AdvancedAccountSetupDialogService {
  private readonly dialog = inject(MatDialog);

  open(data: AdvancedAccountSetupDialogData): MatDialogRef<AdvancedAccountSetupDialogComponent> {
    return this.dialog.open(AdvancedAccountSetupDialogComponent, {
      panelClass: "modal-standard-s",
      data
    });
  }
}
